export class OrderFilterModel {
    public customerId: string;

    constructor() {
        this.customerId = '';
    }
}
